import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import { AnchoredNotificationAlert } from '@noths/polaris-client-ribbons-design-system';

import { ADD_TO_BASKET_ERROR } from '..';
import { useErrorNotificationFocus } from '../hooks/useErrorNotificationFocus';
import { ErrorNotificationWrapper } from './ErrorNotificationWrapper';
import * as styles from '../styles/ProductInfo.styles';

export interface ErrorNotificationProps {
  shouldShow: boolean;
  returnFocusToRef: MutableRefObject<HTMLElement | null>;
}
export const ERROR_NOTIFICATION_TESTID = 'error-notification';
export const ERROR_NOTIFICATION_MESSAGE_ID = 'error-notification-message';

export const ErrorNotification = ({ shouldShow, returnFocusToRef }: ErrorNotificationProps) => {
  const textBoxRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  const [isVisible, setIsVisible] = useState(shouldShow);

  useErrorNotificationFocus(isVisible, returnFocusToRef, textBoxRef);

  useEffect(() => {
    setIsVisible(shouldShow);
  }, [shouldShow]);

  return (
    <ErrorNotificationWrapper>
      <div
        role="alertdialog"
        aria-describedby={ERROR_NOTIFICATION_MESSAGE_ID}
        css={styles.addToBasketAlert}
        data-visible={isVisible}
        data-testid={ERROR_NOTIFICATION_TESTID}
        ref={textBoxRef}
      >
        <AnchoredNotificationAlert onClose={() => setIsVisible(false)}>
          <span id={ERROR_NOTIFICATION_MESSAGE_ID} css={styles.addToBasketAlertTextBox}>
            {ADD_TO_BASKET_ERROR}
          </span>
        </AnchoredNotificationAlert>
      </div>
    </ErrorNotificationWrapper>
  );
};
